import React, { useState, useRef } from "react";
import {
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import {
  User,
  Mail,
  Phone,
  Shield,
  Briefcase,
  Camera,
  Edit,
  Lock
} from "lucide-react";
import { Toast } from "primereact/toast";
import axios from "axios";
import { API_BASE_URL } from "../../constants";

const Profile = () => {
  const [adminData, setAdminData] = useState({
    name: "Brandstrek",
    email: "brandstrekofficial@gmail.com",
    phone: "+917594909991",
    designation: "Admin",
    dob: "1998-01-01",
    department: "Management",
    location: "Kerala, India",
    profilePicture:
      "https://xsgames.co/randomusers/assets/avatars/male/74.jpg",
  });

  const [editData, setEditData] = useState({ ...adminData });
  const [errors, setErrors] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [showEditProfile, setShowEditProfile] = useState(false); // State to toggle edit profile view

  // password
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  })
  const [passwordErrors, setPasswordErrors] = useState({});
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);
  const togglePasswordModal = () => setPasswordModalOpen(!passwordModalOpen);

  const toast = useRef(null);


  const validate = () => {
    const newErrors = {};
    if (!editData.name.trim()) newErrors.name = "Name is required.";
    if (!/^\d{10}$/.test(editData.phone.toString())) {
      newErrors.phone = "Phone number must be 10 digits.";
    }
    if (!editData.department.trim())
      newErrors.department = "Department is required.";
    if (!editData.location.trim()) newErrors.location = "Location is required.";
    if (!editData.designation.trim())
      newErrors.designation = "Designation is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validatePasswordChange = () => {
    const newErrors = {};
    if (!passwordData.currentPassword.trim()) {
      newErrors.currentPassword = "Current password is required.";
    }
    if (!passwordData.newPassword.trim()) {
      newErrors.newPassword = "New password is required.";
    } else if (passwordData.newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters.";
    }
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }
    setPasswordErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    if (validate()) {
      setAdminData(editData);
      setModalOpen(true);
      setShowEditProfile(false); // Hide edit profile after saving
    }
  };

  const handlePasswordSave = async () => {
    if (!validatePasswordChange()) return;

    setIsChangingPassword(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/change-password`, // Update with your API endpoint
        {
          current_password: passwordData.currentPassword,
          new_password: passwordData.newPassword,
          confirm_password: passwordData.confirmPassword,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (response.data && response.data.status === "success") {
        toast.current.show({
          severity: "success",
          summary: "Updated",
          detail: "Password changed successfully!",
          life: 3000,
        });
        // toast.success("Password changed successfully!");
        setPasswordModalOpen(false);
        setPasswordData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      }
      else {
        const errorMsg = response.data.message || "Failed to change password";
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: errorMsg,
          life: 3000,
        });
        // toast.error(response.data.message || "Failed to change password");
      }
    } catch (error) {
      console.error("Password change error:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while changing password",
        life: 3000,
      });
      // toast.error(
      //   error.response?.data?.message ||
      //     "An error occurred while changing password"
      // );
    } finally {
      setIsChangingPassword(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setEditData((prev) => ({ ...prev, profilePicture: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary position-fixed w-100 z-3 ">
        <div className="container-fluid g-5">
          <a className="navbar-brand fw-bold" href="/">
            user
          </a>
        </div>
      </nav>

      <div className="container py-5" style={{ marginTop: "90px" }}>
        <div className="row">
          {/* Profile Card (Visible by default on mobile) */}
          <div
            className={`col-12 col-md-4 mb-4 mb-md-0 ${showEditProfile ? "d-none d-md-block" : ""
              }`}
          >
            <Card className="shadow rounded-4 p-4 h-100 position-relative">
              {/* Edit Button (Top-right corner, visible only on mobile) */}
              <Button
                color="primary"
                className="d-md-none position-absolute rounded-circle p-2"
                style={{ top: "10px", right: "10px", zIndex: 1000 }}
                onClick={() => setShowEditProfile(true)}
              >
                <Edit size={18} />
              </Button>
              <CardBody className="text-center">
                <div className="d-flex flex-column align-items-left position-relative gap-2">
                  <div className="position-relative">
                    <img
                      src={adminData.profilePicture}
                      alt="Profile"
                      className="rounded-circle shadow mb-2"
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <h4 className="fw-bold d-flex flex-column flex-md-row align-items-center gap-2 mb-1">
                    <User size={20} /> <span>{adminData.name}</span>
                  </h4>
                  <p className="text-muted d-flex align-items-center gap-2 mb-1">
                    <Mail size={16} /> <span>{adminData.email}</span>
                  </p>
                  <p className="d-flex align-items-center gap-2 mb-1">
                    <Phone size={16} /> <span>{adminData.phone}</span>
                  </p>
                  <p className="d-flex align-items-center gap-2 mb-1">
                    <Briefcase size={16} /> <span>{adminData.department}</span>
                  </p>
                  <p className="d-flex align-items-center gap-2 mb-1">
                    <Shield size={16} /> <span>{adminData.designation}</span>
                  </p>
                  <Button color="secondary"
                    className="mt-2"
                    onClick={togglePasswordModal}>
                    Change Password
                  </Button>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* Edit Profile Card (Visible only when showEditProfile is true on mobile) */}
          <div
            className={`col-12 col-md-8 ${showEditProfile ? "" : "d-none d-md-block"
              }`}
          >
            <Card className="shadow rounded-4 p-4 h-100">
              <CardBody>
                <h3 className="fw-bold d-flex align-items-center gap-2 mb-4">
                  <Edit size={24} /> Edit Profile
                </h3>
                <Form>
                  <FormGroup className="mb-3">
                    <Label for="profilePicture">Profile Picture</Label>
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                      <div className="position-relative">
                        <img
                          src={editData.profilePicture}
                          alt="Preview"
                          className="rounded-circle shadow"
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                          }}
                        />
                        <div
                          className="position-absolute bottom-0 end-0 bg-white rounded-circle p-1 shadow"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            document.getElementById("uploadImage").click()
                          }
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              document.getElementById("uploadImage").click();
                            }
                          }}
                        >
                          <Camera size={18} />
                        </div>
                      </div>
                      <Input
                        type="file"
                        id="uploadImage"
                        style={{ display: "none" }}
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-4">
                    <Label for="email">Email</Label>
                    <Input
                      type="email"
                      name="email"
                      id="email"
                      value={editData.email}
                      onChange={handleChange}
                      placeholder="Email"
                      className="rounded-3 p-2"
                      disabled
                    />
                  </FormGroup>

                  {[
                    "name",
                    "phone",
                    "department",
                    "designation",
                    "location",
                  ].map((field) => (
                    <FormGroup key={field} className="mb-3">
                      <Label for={field}>
                        {field.charAt(0).toUpperCase() + field.slice(1)}
                      </Label>
                      <Input
                        type="text"
                        name={field}
                        id={field}
                        value={editData[field]}
                        onChange={handleChange}
                        placeholder={field}
                        className="rounded-3 p-2"
                      />
                      {errors[field] && (
                        <div className="text-danger small">{errors[field]}</div>
                      )}
                    </FormGroup>
                  ))}

                  <FormGroup className="mb-4">
                    <Label for="dob">Date of Birth</Label>
                    <Input
                      type="date"
                      name="dob"
                      id="dob"
                      value={editData.dob}
                      onChange={handleChange}
                      className="rounded-3 p-2"
                    />
                  </FormGroup>
                  <div className="d-flex gap-3">
                    <Button
                      color="secondary"
                      className="flex-grow-1 rounded-3 py-2 fw-semibold"
                      onClick={() => setShowEditProfile(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      className="flex-grow-1 rounded-3 py-2 fw-semibold"
                      onClick={handleSave}
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>

      <Modal isOpen={modalOpen} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Success</ModalHeader>
        <ModalBody>Profile updated successfully!</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggleModal}>
            OK
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={passwordModalOpen} toggle={togglePasswordModal} centered>
        <ModalHeader toggle={togglePasswordModal}>
          <Lock size={20} className="me-2" />
          Change Password
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup className="mb-3">
              <Label for="currentPassword">Current Password</Label>
              <Input
                type="password"
                name="currentPassword"
                id="currentPassword"
                value={passwordData.currentPassword}
                onChange={handlePasswordChange}
                placeholder="Enter current password"
                className="rounded-3 p-2"
              />
              {passwordErrors.currentPassword && (
                <div className="text-danger small">
                  {passwordErrors.currentPassword}
                </div>
              )}
            </FormGroup>

            <FormGroup className="mb-3">
              <Label for="newPassword">New Password</Label>
              <Input
                type="password"
                name="newPassword"
                id="newPassword"
                value={passwordData.newPassword}
                onChange={handlePasswordChange}
                placeholder="Enter new password"
                className="rounded-3 p-2"
              />
              {passwordErrors.newPassword && (
                <div className="text-danger small">
                  {passwordErrors.newPassword}
                </div>
              )}
            </FormGroup>

            <FormGroup className="mb-3">
              <Label for="confirmPassword">Confirm New Password</Label>
              <Input
                type="password"
                name="confirmPassword"
                id="confirmPassword"
                value={passwordData.confirmPassword}
                onChange={handlePasswordChange}
                placeholder="Confirm new password"
                className="rounded-3 p-2"
              />
              {passwordErrors.confirmPassword && (
                <div className="text-danger small">
                  {passwordErrors.confirmPassword}
                </div>
              )}
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={togglePasswordModal}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handlePasswordSave}
            disabled={isChangingPassword}
          >
            {isChangingPassword ? (
              <>
                <Spinner size="sm" className="me-2" />
                Changing
              </>
            ) : (
              "Change Password"
            )}
          </Button>
        </ModalFooter>
      </Modal>

      <Toast ref={toast} />
    </>
  );
};

export default Profile;